import { render, staticRenderFns } from "./student-list.vue?vue&type=template&id=d97faff0"
import script from "./student-list.vue?vue&type=script&lang=js"
export * from "./student-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports